function createCookie(name, value, days) {
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
} 

function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}   

function eraseCookie(name) {
  createCookie(name, "", -1);
}

(function() {
  var debounceTimer;
  var cartCurrencySymbol = null;

  function formatMoney(cents) {
    // Use the captured currency symbol if available, otherwise fallback
    var symbol = cartCurrencySymbol || '$';
    return symbol + (cents / 100).toFixed(2);
  }

  function applyCartTotal(cart) {
    if(!cart || typeof cart.total_price !== 'number') return;
    // Capture the currency symbol from the cart object if available
    if (cart.currency && cart.currency.length === 3 && cart.currency_symbol) {
      cartCurrencySymbol = cart.currency_symbol;
    } else if (cart.currency && cart.currency.length === 3 && cart.currency !== 'USD') {
      // fallback: try to infer symbol for common currencies
      var symbols = { 'USD': '$', 'EUR': '€', 'GBP': '£', 'CAD': '$', 'AUD': '$', 'JPY': '¥' };
      cartCurrencySymbol = symbols[cart.currency] || '$';
    }
    var nodes = document.querySelectorAll('[data-rc-cart-total-price]');
    nodes.forEach(function(el) { el.textContent = formatMoney(cart.total_price); });
  }

  function fetchAndApplyCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { applyCartTotal(cart); })
      .catch(function(){});
  }

  function triggerUpdate(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchAndApplyCart, typeof delay === 'number' ? delay : 500);
  }

  if(document.readyState === 'complete' || document.readyState === 'interactive') {
    triggerUpdate(0);
  } else {
    document.addEventListener('DOMContentLoaded', function(){ triggerUpdate(0); });
  };

  ['cart:updated','ajaxCart:updated','rc:cart:update','cart:change','cart:refresh']
    .forEach(function(evt) {
      window.addEventListener(evt, function(){ triggerUpdate(200); });
      document.addEventListener(evt, function(){ triggerUpdate(200); });
    });

  // Listen to interactions within the quick cart
  document.addEventListener('change', function(e) {
    if(e.target && e.target.closest('[data-cart-form]')) triggerUpdate(800);
  });
  document.addEventListener('click', function(e) {
    if(e.target && e.target.closest('[data-cart-form]')) triggerUpdate(800);
    if(e.target && e.target.closest('[data-cart-wrapper] .rc-qc-delete')) triggerUpdate(1000);
  });

  // Intercept fetch calls to cart endpoints to update from the final response
  try {
    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
      var req = originalFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if(/\/cart\/(change|update)\.js|\/cart\.js/.test(url)) {
          req.then(function(res){
            try {
              var clone = res.clone();
              clone.json().then(function(data){
                var cart = data && (data.items ? data : data.cart);
                if (cart && typeof cart.total_price === 'number') applyCartTotal(cart);
                else triggerUpdate(300);
              }).catch(function(){ triggerUpdate(300); });
            } catch(e) { triggerUpdate(300); }
          });
        }
      } catch(e) {}
      return req;
    };
  } catch(e) {}

  // Intercept XHR as some apps/themes still use it
  try {
    var XHR = XMLHttpRequest;
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function(method, url) {
      this.__url = url || '';
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function() {
      var self = this;
      this.addEventListener('load', function() {
        try {
          if (/\/cart\/(change|update)\.js|\/cart\.js/.test(self.responseURL || self.__url)) {
            try {
              var data = JSON.parse(self.responseText);
              var cart = data && (data.items ? data : data.cart);
              if (cart && typeof cart.total_price === 'number') applyCartTotal(cart);
              else triggerUpdate(300);
            } catch(_) { triggerUpdate(300); }
          }
        } catch(e) {}
      });
      return send.apply(this, arguments);
    };
  } catch(e) {}
})();

(function() {
  var resizeTimer;
  var lastViewportWidth = window.innerWidth;
  var resizeObserver;
  var headerGroupTotalHeight = 0;
  var headerGroupStickyHeight = 0;
  var scrollRafPending = false;

  function getHeaderGroupSections() {
    return document.querySelectorAll('.shopify-section-group-header-group');
  }

  function getHeaderElement() {
    return (
      document.querySelector('#shopify-section-header header') ||
      document.querySelector('[id^="shopify-section-"][class*="header"] header') ||
      document.querySelector('header')
    );
  }

  function setHeaderHeightCssVar() {
    var headerGroupSections = getHeaderGroupSections();
    var headerHeight = 0;
    // Height of only the sections that stay pinned on scroll (sticky/fixed),
    // e.g. the header but not a non-sticky announcement bar.
    var stickyHeight = 0;

    if (headerGroupSections.length > 0) {
      headerGroupSections.forEach(function(section) {
        headerHeight += section.offsetHeight;
        var position = getComputedStyle(section).position;
        if (position === 'sticky' || position === 'fixed') {
          stickyHeight += section.offsetHeight;
        }
      });
    } else {
      var header = getHeaderElement();
      if (!header) return;
      headerHeight = header.offsetHeight;
      var headerPosition = getComputedStyle(header).position;
      if (headerPosition === 'sticky' || headerPosition === 'fixed') {
        stickyHeight = headerHeight;
      }
    }

    if (headerHeight <= 0) return;

    headerGroupTotalHeight = Math.ceil(headerHeight);
    headerGroupStickyHeight = Math.ceil(stickyHeight);
    updateHeaderHeightCssVar();
  }

  // --header-height is the current bottom edge of the header group in viewport
  // coordinates: the non-sticky part (announcement bar) scrolls away 1:1 with
  // the page, so the value moves from the full group height down to the height
  // of the pinned sections. Do not use it for static layout math.
  function updateHeaderHeightCssVar() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var bottom = Math.max(headerGroupStickyHeight, headerGroupTotalHeight - scrollY);
    document.documentElement.style.setProperty('--header-height', bottom + 'px');
  }

  function onScroll() {
    if (scrollRafPending) return;
    scrollRafPending = true;
    requestAnimationFrame(function() {
      scrollRafPending = false;
      updateHeaderHeightCssVar();
    });
  }

  function observeHeaderGroup() {
    if (typeof ResizeObserver === 'undefined') return;

    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    resizeObserver = new ResizeObserver(setHeaderHeightCssVar);

    var sections = getHeaderGroupSections();
    if (sections.length > 0) {
      sections.forEach(function(section) {
        resizeObserver.observe(section);
      });
      return;
    }

    var header = getHeaderElement();
    if (header) resizeObserver.observe(header);
  }

  function onViewportResize() {
    if (window.innerWidth === lastViewportWidth) return;
    lastViewportWidth = window.innerWidth;

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setHeaderHeightCssVar, 100);
  }

  function init() {
    setHeaderHeightCssVar();
    observeHeaderGroup();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  window.addEventListener('load', function() {
    setHeaderHeightCssVar();
    observeHeaderGroup();
  });
  window.addEventListener('resize', onViewportResize);
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();